import type { ReactElement } from 'react';
import './ActionArrow.css';

/**
 * The single arrow mark for text navigation actions such as Read more and
 * View more. Direction, stroke, and proportions are deliberately centralized.
 */
export function ActionArrow({ className = '' }: { className?: string }): ReactElement {
  return (
    <svg
      className={`action-arrow${className ? ` ${className}` : ''}`}
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M6 14 14 6M8 6h6v6" />
    </svg>
  );
}
